import {
    useCallback,
    useEffect
} from 'react';
import {
    useDispatch,
    useSelector
} from 'react-redux';

import { setFormData } from '../../../actions/forms';
import { Page } from '../../../common';
import { getFormData } from '../../../selectors/forms';
import { applyFAKIcon } from '..';
import { DrugsStoresList } from '../DrugstoresList';

export const DrugDetails = applyFAKIcon(
    ({
        navigation,
        route: {
            params: {
                drug,
                sortBy = 'totalPrice',
                from = 'drugDetails',
            },
        },
    }) => {
        const dispatch = useDispatch();
        const forms = useSelector(getFormData);
        const back = useCallback(() => {
            if (from === 'basket') {
                navigation.pop();
                navigation.navigate('FirstAidKit');
                return false;
            }
            navigation.goBack();
            return false;
        }, [from, navigation]);

        useEffect(() => {
            if (!forms?.DrugDetails?.back) {
                dispatch(
                    setFormData({
                        DrugDetails: {
                            back,
                            logName: 'DrugDetails',
                        },
                    }),
                );
            }
        }, [dispatch,
            forms?.DrugDetails?.back,
            back]);

        return (
            <Page name="drug-details">
                {/* <DrugInfo drug={drug} /> */}
                <DrugsStoresList
                    drugs={[ drug ]}
                    navigation={navigation}
                    sortBy={sortBy}
                    from={from}
                    firstAidKit={from === 'basket'}
                />
            </Page>
        );
    },
);
